<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch09"></a><a id="page_10"></a><a href="#/contents#ch09"><b>Trash Talk</b></a></h2>
<p class="noindent"><span>The average American throws away about 10 pounds of trash per day.</span></p>
<p class="noindent"><span>Newspapers take up the most space in landfills.</span></p>
<p class="noindent"><span>Almost 7 million tons of clothing and fabric are thrown away every year. Just 12 percent of that is reused or recycled.</span></p>
<p class="noindent"><span>It takes 80 to 100 years for an aluminum can to degrade.</span></p>
<p class="noindent"><span>In 2007, Americans threw out twice as much trash as they did in 1960.</span></p>
<p class="noindent"><span>By the year 2020, the city of San Francisco plans to recycle all of its trash.</span></p>
<p class="noindent"><span>In 2002, astronauts removed 4,000 pounds of trash from the International Space Station. Some of it was brought back to Earth in the space shuttle, but the rest was stuffed into an unmanned Russian rocket and burned up in Earth’s atmosphere.</span></p>
<p class="noindent"><span>Most common litter: cigarette butts. Smokers toss 4.5 trillion butts a year.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter09.vue?4a46374c